<template>
    <div>
        <vue-apex-charts ref="chart" type="line" height="400" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'
import ElementEnum from '@/app/shared/ElementEnum';
import MaterialTypeEnum from '../../MaterialTypeEnum';
import GradeCalculationTypeEnum  from "../../GradeCalculationTypeEnum.js";

const themeColors = ['#000000', '#FFD700', '#EA5455', '#FF9F43', '#1E1E1E']

export default {
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartOptions: {
        colors: themeColors,
        chart: {
          stacked: false,
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          }
        },
        stroke: {
          width: 4,
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '25%'
          }
        },
        labels: [],
        markers: {
          size: 0
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: [
          {
            title: {
              text: this.$systemUnits.getTonnageLabel()
            },
            min: 0,
            labels: {
              formatter: (val) => {
                return val.toFixed(0)
              }
            }
          },
          {
            opposite: true,
            title: {
              text: 'Grade'
            },
            min: 0,
            labels: {
              formatter: (val) => {
                return val.toFixed(2)
              }
            }
          }
        ],
        tooltip: {
          shared: true,
          intersect: false,
          y: [
            {
              formatter: (y) => {
                if (typeof y !== "undefined") {
                  return y.toFixed(0);
                }
                return y;

              }
            },
            {
              formatter: (y) => {
                if (typeof y !== "undefined") {
                  return y.toFixed(4);
                }
                return y;

              }
            }
          ]
        }
      },
      series: []
    };
  },

  methods: {
    defineDiagramSettings(gradeCalculation) {
      const dates = this.$store.state.gradeControl.mucks.filter(m => m.materialType === MaterialTypeEnum.Ore).map(m => m.extractionDate).filter((value, index, self) => self.indexOf(value) === index);
      dates.sort((a, b) => { return new Date(b) - new Date(a) });
      const labels = [];
      const tonnages = [];
      const weightedGrades = [];
      dates.forEach(date => {
        labels.push(this.$options.filters.toDate(date))
        const results = this.$store.state.gradeControl.mucks.filter(m => m.extractionDate === date && m.materialType === MaterialTypeEnum.Ore);
        if (typeof results !== 'undefined') {
          let tonnage = 0;
          let consideredGradeTonnage = 0;
          let goldGrams = 0;
          results.forEach(result => {
            let sampleResults = [];

            switch (gradeCalculation) {
            case GradeCalculationTypeEnum.SampleOnly:
              sampleResults = result.sampleOnlyResults;
              break;
            case GradeCalculationTypeEnum.SampleOrForecast:
              sampleResults = result.sampleOrForecastResults;
              break;
            case GradeCalculationTypeEnum.SampleOnlyCapped:
              sampleResults = result.sampleOnlyCappedResults;
              break;
            case GradeCalculationTypeEnum.SampleOrForecastCapped:
              sampleResults = result.sampleOrForecastCappedResults;
              break;
            }

            const goldGradeResult = sampleResults.find(g => g.element === ElementEnum.Gold);
            if (goldGradeResult && goldGradeResult.grade > 0) {
              consideredGradeTonnage += result.tonnage;
              goldGrams += goldGradeResult.grade * result.tonnage;
            }

            tonnage += result.tonnage;

          });

          tonnages.push(this.$systemUnits.convertTonnage(tonnage));
          if (consideredGradeTonnage !== 0) {
            weightedGrades.push(goldGrams / this.$systemUnits.convertTonnage(consideredGradeTonnage))
          } else {
            weightedGrades.push(0)
          }

        }
      });

      const tonnageSerie = {
        name: this.$systemUnits.getTonnageLabel(),
        type: 'column',
        data: tonnages
      }

      const goldGradesSerie = {
        name: 'Gold Grade ' + this.$t(this.$store.getters.isProjectImperial ? 'GradeControl.CappingUnitImperial' : 'GradeControl.CappingUnit'),
        type: 'line',
        data: weightedGrades
      }

      this.series = [tonnageSerie, goldGradesSerie];

      this.$refs.chart.updateOptions({ labels });


    }
  }
};
</script>
